import { type OrchestratedCommonListingDetails } from '@b-stock/fe-core/bstock-next/queries'

import { FixedTermsOrderDetailsButton } from './FixedTermsOrderDetailsButton'
import { ButtonContainer } from './styledComponents'

export const InvoiceSpotActionColumn = ({
  listing,
}: {
  listing: OrchestratedCommonListingDetails
}) => (
  <ButtonContainer>
    <FixedTermsOrderDetailsButton listing={listing} />
  </ButtonContainer>
)
